// src/components/PreviewPDF.js
import React, { useRef, useState, useEffect } from 'react';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { useEstadoApp } from '../context/EstadoAppContext';
import { requisitos } from '../datos/requisitos';

// Importar imágenes para el PDF
import encabezadoImg from './informes/encabezado_A4.png';
import pieImg from './informes/pie_hoja_A4.png';


const PreviewPDF = ({ data, onClose }) => {
  // 1. Todos los Hooks primero
  const pdfRef = useRef(null);
  const { selectedObra } = useEstadoApp();
  console.log("QUE HAY EN selectedObra", selectedObra)
  const [isLoading, setIsLoading] = useState(true);
  const [documentosSeleccionados, setDocumentosSeleccionados] = useState([]);
  const [areaResponsable, setAreaResponsable] = useState();
  const [tipoSubsidio, setTipoSubsidio] = useState();
  //const [requisitosHabilitados, setRequisitosHabilitados] = useState([]);
  const [labelsSeleccionados, setLabelsSeleccionados] = useState([]);
  const [labelsNoSeleccionados, setLabelsNoSeleccionados] = useState([]);
  const [arrayLabelsSeleccionados, setArrayLabelsSeleccionados] = useState([]);
  const [arrayLabelsNoSeleccionados, setArrayLabelsNoSeleccionados] = useState([]);
  const [observacionesReporte, setObservacionesReporte] = useState('');  
  
  // Estado para manejar los datos de la obra
  const [obraData, setObraData] = useState(null);
  console.log("QUE TENGO en obraData ---->", obraData)

  // Definición de los requisitos fuera del componente para evitar re-creación
	/*const requisitos = [
		// Subtítulo Etapa I
		{
			id: 'etapa_i',
			label: 'ETAPA I',
			isSectionHeader: true,
			isEnabled: () => areaResponsable === 'ÁREA DE MEJORAS'
		},
		{
			id: 'nota_solicitud',
			label: 'Nota de solicitud',
			isEnabled: () => true
		},
		{
			id: 'informe_dominio',
			label: 'Informes de dominio',
			isEnabled: () => areaResponsable === 'ÁREA DE PROYECTOS'
		},
		{
			id: 'designacion_intendente',
			label: 'Designación Intendente',
			isEnabled: () => tipoSubsidio === 'Subsidio a municipio'
		},
		{
			id: 'anexo_social',
			label: 'Anexo social',
			isEnabled: () => areaResponsable === 'ÁREA DE PROYECTOS'
		},
		{
			id: 'anexo_tecnico',
			label: 'Anexo técnico',
			isEnabled: () => areaResponsable === 'ÁREA DE PROYECTOS'
		},
		{
			id: 'computo_y_presupuesto',
			label: 'Cómputo y presupuesto',
			isEnabled: () => areaResponsable === 'ÁREA DE PROYECTOS'
		},
		{
			id: 'planos_de_proyecto',
			label: 'Proyectos / Planos',
			isEnabled: () => true
		},
		{
			id: 'prefactibilidad_es_de_servicio_s_suscripta_prestataria',
			label: 'Prefactibilidad/es de servicio/s suscripta por la prestataria',
			isEnabled: () => areaResponsable === 'ÁREA DE PROYECTOS'
		},
		{
			id: 'constancia_de_cbu',
			label: 'Constancia de CBU',
			isEnabled: () => true
		},
		{
			id: 'acta_acuerdo',
			label: 'Acta acuerdo',
			isEnabled: () => areaResponsable === 'ÁREA DE PROYECTOS'
		},
		{
			id: 'nota_regulacion_dominal',
			label: 'Nota Regulación Dominial',
			isEnabled: () => areaResponsable === 'ÁREA DE MEJORAS'
		},
		{
			id: 'nota_certificacion_pago_arquitecto_mmdo',
			label: 'Nota Certificacion Pago Arquitecto/MMdO',
			isEnabled: () => tipoSubsidio === 'Subsidio a ONG' && areaResponsable === 'ÁREA DE MEJORAS'
		},
		{
			id: 'convenio_con_certificado',
			label: 'Convenio con certificado',
			isEnabled: () => areaResponsable === 'ÁREA DE MEJORAS'
		},
		{
			id: 'pago_a_certif',
			label: 'Pago a certificador',
			isEnabled: () => areaResponsable === 'ÁREA DE MEJORAS'
		},
		{
			id: 'informe_final',
			label: 'Informe final',
			isEnabled: () => areaResponsable === 'ÁREA DE MEJORAS'
		},
		{
			id: 'listado_beneficiarios',
			label: 'Listado Beneficiarios',
			isEnabled: () => areaResponsable === 'ÁREA DE MEJORAS'
		},
		{
			id: 'pago_a_beneficiarios',
			label: 'Pago a Benficiarios',
			isEnabled: () => areaResponsable === 'ÁREA DE MEJORAS'
		},
		{
			id: 'anexo_fotografico',
			label: 'Anexo Fotográfico',
			isEnabled: () => areaResponsable === 'ÁREA DE MEJORAS'
		},
		// Subtítulo Etapa II
		{
			id: 'etapa_ii',
			label: 'ETAPA II',
			isSectionHeader: true,
			isEnabled: () => areaResponsable === 'ÁREA DE MEJORAS'
		},
		{
			id: 'nota_solicitud_e2',
			label: 'Nota solicitud E2',
			isEnabled: () => areaResponsable === 'ÁREA DE MEJORAS'
		},
		{
			id: 'proyecto_e2',
			label: 'Proyecto E2',
			isEnabled: () => areaResponsable === 'ÁREA DE MEJORAS'
		},
		{
			id: 'nota_gastos_operativos',
			label: 'Nota Gastos Operativos',
			isEnabled: () => tipoSubsidio === 'Subsidio a ONG' && areaResponsable === 'ÁREA DE MEJORAS'
		},
		{
			id: 'comprobante_microcredito',
			label: 'Comprobante microcrédito o factura',
			isEnabled: () => areaResponsable === 'ÁREA DE MEJORAS'
		},
		{
			id: 'informe_rendiciones',
			label: 'Informe Rendiciones',
			isEnabled: () => areaResponsable === 'ÁREA DE MEJORAS'
		},
		{
			id: 'ddjj',
			label: 'DDJJ',
			isEnabled: () => areaResponsable === 'ÁREA DE MEJORAS'
		},
		{
			id: 'acuerdo_mutuo',
			label: 'Acuerdo Mutuo',
			isEnabled: () => areaResponsable === 'ÁREA DE MEJORAS'
		},
		{
			id: 'nomina_beneficiarios',
			label: 'Nomina de Beneficiarios',
			isEnabled: () => areaResponsable === 'ÁREA DE MEJORAS'
		},
		{
			id: 'plan_financiamiento',
			label: 'Plan de Financiamiento',
			isEnabled: () => areaResponsable === 'ÁREA DE MEJORAS'
		}
	];*/
  
  // Función para obtener los datos del formulario B
  const getFormB_Tramitacion = async (idPartidoObra) => {
    if (!idPartidoObra) return;
    
    const urlFormB = `/api/form_b_tramitacion/${idPartidoObra}`;
    const headers = { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*' };

    try {
      const response = await fetch(urlFormB, { headers });

      if (!response.ok) {
        if (response.status === 404) {
          console.log("Formulario no encontrado");
        } else {
          throw new Error(`Error HTTP! status: ${response.status}`);
        }
        return;
      }

      const data = await response.json();
      setDocumentosSeleccionados(data.documentos_seleccionados || []);
      setObservacionesReporte(data.observaciones_reporte || '');
      
    } catch (error) {
      console.error('Error al buscar formulario por ID:', error);
      setDocumentosSeleccionados([]);
    } finally {
      setIsLoading(false);
    }
  };
  
 // 2. Un único useEffect para manejar la carga inicial y cambios
 useEffect(() => {
    // Si selectedObra existe, actualizamos el estado local
    if (selectedObra) {
      setObraData(selectedObra);
	  setAreaResponsable(selectedObra.area_responsable);
	  setTipoSubsidio(selectedObra.tipo_subsidio);

      // Si tiene id, llamamos a la función para obtener el formulario B
      if (selectedObra.id_partido_obra) {
        getFormB_Tramitacion(selectedObra.id_partido_obra);
      } else {
        // Si no tiene id, terminamos la carga
        setIsLoading(false);
      }
    } else {
      // Si no hay selectedObra, terminamos la carga y el componente mostrará el mensaje de error
      setIsLoading(false);
    }
  }, [selectedObra]); // Dependencia del useEffect

  // Efecto para calcular los requisitos habilitados cuando cambian documentosSeleccionados, areaResponsable o tipoSubsidio
  /*RESPALDO
	useEffect(() => {
		if (Object.keys(documentosSeleccionados).length > 0) {
		// Filtrar requisitos habilitados según las condiciones
		const requisitosHabilitados = requisitos.filter(req => {
			if (req.isSectionHeader) {
				return req.isEnabled();
			}
			return req.isEnabled() && documentosSeleccionados.hasOwnProperty(req.id);
		});
		//setRequisitosHabilitados(habilitados);
  
		// Separar en documentos presentados y no presentados
		const nuevosPresentados = [];
		const nuevosSinPresentar = [];
		let currentSection = '';
  
		requisitosHabilitados.forEach(req => {
			const item = {
				id: req.id,
				label: req.label,
				isSectionHeader: req.isSectionHeader || false,
				section: currentSection
			};

			if (req.isSectionHeader) {
				currentSection = req.label;
				// Los encabezados van a ambas listas para mantener la estructura
				nuevosPresentados.push(item);
				nuevosSinPresentar.push(item);
			} else {
				// Verificar si está seleccionado (true) o no (false/undefined)
				if (documentosSeleccionados[req.id] === true) {
					nuevosPresentados.push({ ...item, presentado: true });
				} else {
					nuevosSinPresentar.push({ ...item, presentado: false });
				}
			}
		});
  
		setArrayLabelsSeleccionados(nuevosPresentados);
		setArrayLabelsNoSeleccionados(nuevosSinPresentar);

		// mostrar como un array 
		setLabelsSeleccionados(
			nuevosPresentados
				.filter(item => !item.isSectionHeader && item.presentado)
				.map(item => item.label)
		);

		setLabelsNoSeleccionados(
			nuevosSinPresentar
				.filter(item => !item.isSectionHeader && !item.presentado)
				.map(item => item.label)
		);
		}
	}, [documentosSeleccionados, areaResponsable, tipoSubsidio]);*/
	useEffect(() => {
		// Si no hay documentos seleccionados, no hacemos nada.
		if (Object.keys(documentosSeleccionados).length === 0) {
			setArrayLabelsSeleccionados([]);
			setArrayLabelsNoSeleccionados([]);
			setLabelsSeleccionados([]);
			setLabelsNoSeleccionados([]);
			return;
		}
	
		const nuevosPresentados = [];
		const nuevosSinPresentar = [];
		let labelsPresentados = [];
		let labelsNoPresentados = [];
		let currentSection = '';
	
		// Filtra y procesa en un solo bucle
		/*requisitos.forEach(req => {			
			// Verifica si el requisito está habilitado
			const isEnabled = req.isSectionHeader ? req.isEnabled() : req.isEnabled() && documentosSeleccionados.hasOwnProperty(req.id);
			
			if (isEnabled) {
				const item = {
					id: req.id,
					label: req.label,
					isSectionHeader: req.isSectionHeader || false,
					section: currentSection
				};
				
				if (req.isSectionHeader) {
					// Los encabezados van a ambas listas
					currentSection = req.label;
					nuevosPresentados.push(item);
					nuevosSinPresentar.push(item);
				} else {
					// Se separan según el estado de selección
					const isSelected = documentosSeleccionados[req.id] === true;
					if (isSelected) {
						nuevosPresentados.push({ ...item, presentado: true });
						labelsPresentados.push(item.label);
					} else {
						nuevosSinPresentar.push({ ...item, presentado: false });
						labelsNoPresentados.push(item.label);
					}
				}
			}
		});*/
		requisitos.forEach(req => {
            // Verifica si el requisito está habilitado
            // Pasa las variables de estado como argumentos a isEnabled()
            const isEnabled = req.isSectionHeader
                ? req.isEnabled(areaResponsable, tipoSubsidio)
                : req.isEnabled(areaResponsable, tipoSubsidio) && documentosSeleccionados.hasOwnProperty(req.id);
            
            if (isEnabled) {
                const item = {
                    id: req.id,
                    label: req.label,
                    isSectionHeader: req.isSectionHeader || false,
                    section: currentSection
                };
                
                if (req.isSectionHeader) {
                    // Los encabezados van a ambas listas
                    currentSection = req.label;
                    nuevosPresentados.push(item);
                    nuevosSinPresentar.push(item);
                } else {
                    // Se separan según el estado de selección
                    const isSelected = documentosSeleccionados[req.id] === true;
                    if (isSelected) {
                        nuevosPresentados.push({ ...item, presentado: true });
                        labelsPresentados.push(item.label);
                    } else {
                        nuevosSinPresentar.push({ ...item, presentado: false });
                        labelsNoPresentados.push(item.label);
                    }
                }
            }
        });
	
		// Actualiza los estados de una sola vez
		setArrayLabelsSeleccionados(nuevosPresentados);
		setArrayLabelsNoSeleccionados(nuevosSinPresentar);
		setLabelsSeleccionados(labelsPresentados);
		setLabelsNoSeleccionados(labelsNoPresentados);
	
	}, [documentosSeleccionados, areaResponsable, tipoSubsidio]);
  
  // 3. Si no hay datos, mostramos un mensaje
  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
      </div>
    );
  }
  
  if (!selectedObra || !obraData) {
    return (
      <div className="p-4 text-center text-red-600">
        No hay datos para generar el informe.
      </div>
    );
  }
  
  // 4. Destructuring de obraData (que sabemos que no es null aquí)
  const {
    nombre_obra,
    id_partido_obra,
    tipo_subsidio,
    area_responsable,
    array_obras_expediente = [], //add 6-oct-2025
    partido_nombre,
    lc_21_localidad,//no es ---> localidad,
    //barrio,
	barrio_rppvap_nombre,
	barrio_otro_nombre,
    organismo_solicitante,
    organismo_otro,
    programa_lineamiento,
    modalidad,
    monto_obra,
    tipo_contratacion,
    plazo_obra,
    beneficiarios,
    lc_22_identificacion_catastral,
    lc_22_1_datos_catastrales,
    lc_22_2_cuadro_calles,
    lc_24_titular_dominio,
    descripcion_proyecto,
    array_tipo_subtipo_proyecto,
    documentos,
    requisitosHabilitados,
    //observaciones_reporte,
    //labelsSeleccionados,
    //labelsNoSeleccionados,
    //arrayLabelsSeleccionados,
    //arrayLabelsNoSeleccionados,
    reportData
  } = obraData || {};	
  console.log("obraData ---->", obraData)

	// 1. Usar find() para obtener el objeto "Proyecto" - add 6-oct-2025
	const objeto_proyecto = array_obras_expediente?.find(item => item.objeto_o === "Proyecto");

	// 2. Extraer el valor de expediente_o si el objeto fue encontrado - add 6-oct-2025
	let expediente_proyecto = null;
	if (objeto_proyecto) {
		expediente_proyecto = objeto_proyecto.expediente_o;
	}

  // Efecto para cargar los datos del formulario B de tramitación	

	
	const handleDownloadPDF = async () => {
		try {
			setIsLoading(true);
			const element = pdfRef.current;
			if (!element) return;
	
			// Convertir el contenido a imagen con html2canvas
			const canvas = await html2canvas(element, { 
				scale: 2,
				//useCORS: true,
				//logging: true
				
			});
	
			const imgData = canvas.toDataURL('image/png');
			const pdf = new jsPDF('p', 'mm', 'a4');
			const pdfWidth = pdf.internal.pageSize.getWidth();
			const pdfHeight = pdf.internal.pageSize.getHeight();
	
			// Ajustar la imagen al tamaño de la página
			const imgWidth = canvas.width;
			const imgHeight = canvas.height;
			const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
			const finalWidth = imgWidth * ratio;
			const finalHeight = imgHeight * ratio;

			// Centrar horizontalmente
			const x = (pdfWidth - finalWidth) / 2;
			
			// Agregar la imagen al PDF
			pdf.addImage(imgData, 'PNG', x, 0, finalWidth, finalHeight);
			
			// Guardar el PDF con el ID de la obra
			//si existe id_partido_obra usar en el nombre y si no existe usar solo informe tecnico
			if (selectedObra?.id_partido_obra) {
				const obraId = selectedObra?.id_partido_obra;
				pdf.save(`informe_tecnico_obs_${obraId}.pdf`);
			} else {
				pdf.save('informe_tecnico_obs.pdf');
			}
		} catch (error) {
			console.error('Error al generar el PDF:', error);
		} finally {
			setIsLoading(false);
		}
	};
	/*const handleDownloadPDF = async () => {
		const element = pdfRef.current;
		if (!element) return;

		const canvas = await html2canvas(element, { scale: 2 });
		const imgData = canvas.toDataURL('image/png');

		const pdf = new jsPDF('p', 'mm', 'a4');
		const pdfWidth = pdf.internal.pageSize.getWidth();
		const pdfHeight = pdf.internal.pageSize.getHeight();

		// Asegúrate de que la imagen se ajuste a la página manteniendo la relación de aspecto
		const imgWidth = canvas.width;
		const imgHeight = canvas.height;
		const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);

		const finalWidth = imgWidth * ratio;
		const finalHeight = imgHeight * ratio;

		// Agregar la imagen con un pequeño margen
		pdf.addImage(imgData, 'PNG', 0, 0, finalWidth, finalHeight);
		pdf.save('informe_tecnico.pdf');
	};*/


	
	//misntras se ejecuta el fetch mostrar un mensaje de loading
	if (isLoading) {
		return (
			<div className="flex items-center justify-center h-screen">
				<div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
			</div>
		);
	}

	// Mover la verificación después de los Hooks
	if (!selectedObra) {
		return (
			<div className="p-4 text-center text-red-600">
				No hay datos para generar el informe.
			</div>
		);
	}
	
	{/*necesito que el div que contiene todo el contenido ocupe mas ancho de pantalla	 */}
	return (
		<div className="bg-white p-8 px-10 sm:p-12 shadow-xl rounded-lg w-full max-w-6xl mx-auto my-6 font-sans border border-gray-200">
			<button
				onClick={handleDownloadPDF}
				className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-teal-600 hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500"
			>
				<svg className="-ml-1 mr-2 h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
					<path fillRule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clipRule="evenodd" />
				</svg>
				Descargar PDF
			</button>

			<div className="p-10" ref={pdfRef}>{/* Todo dentro del pdfRef */}
				{/* Previsualización del encabezado */}
				{/*
				<div className="mb-6 overflow-hidden flex justify-end">
					<img
						src={encabezadoImg}
						alt="Encabezado del informe"
						className="h-auto"
						style={{ maxHeight: '100px', objectFit: 'contain' }}
					/>
				</div>
				*/}
				<div className="mb-6">
					<img
						src={encabezadoImg}
						alt="Encabezado del informe"
						className="w-full h-auto max-h-[250px] object-cover"
						//style={{ maxHeight: '100px', objectFit: 'contain' }}
					/>
				</div>

				{/* Contenido principal */}

				<div className="text-center mb-6">
					<h1 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-1">
						Informe técnico con observaciones
					</h1>
					<h2 className="text-lg sm:text-xl text-gray-600">
						Dirección Provincial de Intervenciones Complementarias
					</h2>
				</div>

				<div className="grid grid-cols-1 sm:grid-cols-1 gap-x-8 gap-y-4 text-sm sm:text-base text-gray-700 mb-6 border-b pb-6">
					<div>
						<p>
							<strong className="font-semibold text-gray-900">
								Nombre del Proyecto/alias:
							</strong>{' '}
							{nombre_obra}
						</p>
					</div>
					{/*en un div alineado a la derecha - add 6-oct-2025: cambiamos expediente x expediente_proyecto*/}
					<div className="text-right">
						<p>
							<strong className="font-semibold text-gray-900">
								Referente al Expediente:
							</strong>{' '}
							{expediente_proyecto ? expediente_proyecto : 'No especificado'}
						</p>
					</div>
					<p>
						<strong className="font-semibold text-gray-900">Localización:</strong>{' '}
						{/*Partido: {partido_nombre} / Localidad: {lc_21_localidad} /{' '}*/}
						Partido: {partido_nombre} - Localidad: {lc_21_localidad} - Barrio: {barrio_rppvap_nombre || barrio_otro_nombre}
					</p>
					<div>
						<p>
							<strong className="font-semibold text-gray-900">
								Organismo Solicitante:
							</strong>
							{' '}
							{
								tipo_subsidio === 'Subsidio a municipio'
									? `Municipio de ${partido_nombre || ''}`
									: tipo_subsidio === 'Subsidio a ONG'
										? `ONG ${organismo_solicitante || ''}`
										: organismo_otro || ''
							}
						</p>
					</div>
					<div>
						<p>
							<strong className="font-semibold text-gray-900">Programa:</strong>{' '}
							{programa_lineamiento}
						</p>
					</div>
					<div>
						<p>
							<strong className="font-semibold text-gray-900">Modalidad:</strong>{' '}
							{modalidad}
						</p>
					</div>
					<div>
						<p>
							<strong className="font-semibold text-gray-900">
								Monto de obra en $:
							</strong>{' '}
							{Number(monto_obra).toLocaleString('es-AR')}
						</p>
					</div>
					<div>
						<p>
							<strong className="font-semibold text-gray-900">
								Tipo de contratación:
							</strong>{' '}
							{tipo_contratacion}
						</p>
					</div>
					<div>
						<p>
							<strong className="font-semibold text-gray-900">
								Plazo de obra:
							</strong>{' '}
							{plazo_obra}
						</p>
					</div>
					<div>
						<p>
							<strong className="font-semibold text-gray-900">
								Beneficiarios:
							</strong>{' '}
							{beneficiarios}
						</p>
					</div>
					<div>
						<p>
							<strong className="font-semibold text-gray-900">
								**Ubicación del Proyecto**
							</strong>{' '}
							<br />

							{lc_22_identificacion_catastral === 'SI' && (
								<div>
									<p>
										<strong className="font-semibold text-gray-900">Datos catastrales: </strong>
										{' '}{lc_22_1_datos_catastrales}
									</p>
								</div>
							)}

							<br />
							<div>
								<div style={{ whiteSpace: 'pre-wrap' }}>
									<strong className="font-semibold text-gray-900">Cuadro de calles: </strong>
									{' '}{lc_22_2_cuadro_calles}
								</div>
							</div>
							<br />
							<strong className="font-semibold text-gray-900">Titular de dominio: </strong>{' '}
							{lc_24_titular_dominio}
						</p>
					</div>
				</div>

				<div className="mb-6">
					<h3 className="text-xl font-semibold text-gray-800 mb-2">
						Categorías por ítems de obra:
					</h3>
					{array_tipo_subtipo_proyecto?.length > 0 ? (
						<ul className="list-disc list-inside space-y-1 text-gray-700">
							{array_tipo_subtipo_proyecto?.map((item, index) => (
								<li key={index}>
									<strong className="font-medium">{item.tipo}:</strong>{' '}
									{item.subtipo} - {item.cantidad} - {item.unidad}
								</li>
							))}
						</ul>
					) : (
						<p className="text-gray-500 italic">No se especificaron ítems de obra.</p>
					)}
				</div>

				<div className="mb-6">
					<h3 className="text-xl font-semibold text-gray-800 mb-2">
						Descripción del proyecto:
					</h3>
					<div className="text-gray-700" style={{ whiteSpace: 'pre-wrap' }}>{descripcion_proyecto}</div>
				</div>

				<div className="border-t pt-6">
					<p className="text-gray-700 mb-4">
						A partir del análisis de la propuesta y la documentación técnica
						presentada, la Dirección Provincial de Intervenciones Complementarias
						realiza las siguientes observaciones:
					</p>
					<div className="space-y-2 text-gray-700">

						<strong className="font-semibold text-gray-900">
							Se presentó la siguiente documentación:
						</strong>{' '}
						{arrayLabelsSeleccionados.length > 0 ? (
							<ul className="list-disc list-inside space-y-1 text-gray-700">
								{arrayLabelsSeleccionados.map((item) => {
									// Verificamos si es un encabezado
									if (item.isSectionHeader) {
										// Si es un encabezado, lo renderizamos como un <h3> o similar
										return (
											<h3 key={item.id} style={{ marginTop: '20px', marginBottom: '10px' }}>
												{item.label}
											</h3>
										);
									} else {
										// Si no es un encabezado, lo renderizamos como un elemento de lista <li>
										return (
											<li key={item.id} className="documento-presentado">
												{item.label}
											</li>
										);
									}
								})}
							</ul>
						) : (
							<p className="text-gray-500 italic">Sin documentos presentados.</p>
						)}


						<strong className="font-semibold text-gray-900">
							Documentación faltante, incompleta y/o a corregir:
						</strong>{' '}
						{arrayLabelsNoSeleccionados.length > 0 ? (
							<ul className="list-disc list-inside space-y-1 text-gray-700">
								{arrayLabelsNoSeleccionados.map((item) => {
									// Verificamos si es un encabezado
									if (item.isSectionHeader) {
										// Si es un encabezado, lo renderizamos como un <h3> o similar
										return (
											<h3 key={item.id} style={{ marginTop: '20px', marginBottom: '10px' }}>
												{item.label}
											</h3>
										);
									} else {
										// Si no es un encabezado, lo renderizamos como un elemento de lista <li>
										return (
											<li key={item.id} className="documento-presentado">
												{item.label}
											</li>
										);
									}
								})}
							</ul>
						) : ''}
						<div style={{ whiteSpace: 'pre-wrap' }}>
							<strong className="font-semibold text-gray-900">
								Observaciones:
							</strong>{' '}
							{observacionesReporte}
						</div>

					</div>
				</div>



				<div className="mt-8 text-right text-sm text-gray-500">
					<p>Fecha de salida: {new Date().toLocaleDateString('es-AR')}</p>
					<p>.</p>
				</div>

				
								
				{/* Previsualización del pie de página */}
				<div className="mb-6">
					<img
						src={pieImg}
						alt="Pie de página del informe"
						className="w-full h-auto"
						//className="w-full h-auto max-h-[250px] object-cover"
						// Si necesitas limitar la altura máxima, puedes añadir:
						// style={{ maxHeight: '250px', objectFit: 'contain' }}
						// Pero esto podría impedir que la imagen ocupe todo el ancho si es muy alta.
					/>
				</div>

				{/* Previsualización del pie de página:
				un grid de dos clumnas. Una con texto, la otra con la imagen
				Por ahora solo usar un div con todo el texto y la imagen
				*/}
				{/*
				<div className="mt-6 border border-gray-200 rounded-lg overflow-hidden">
					<div className="grid grid-cols-4 gap-4 p-4 bg-white items-center">
						Primera columna - Texto (1/4 del ancho)
						<div className="col-span-1 text-left">
							<p className="text-xs text-gray-500 mt-1">Subsecretaría de Hábitat de la Comunidad</p>
							<p className="text-sm text-gray-700 font-medium">Dirección Provincial de Intervenciones Complementarias</p>
							<p className="text-xs text-gray-500 mt-1">Ministerio de Desarrollo Social</p>
						</div>
						
						Segunda columna - Imagen (3/4 del ancho)
						<div className="col-span-3 flex justify-end items-center">
							<img
								src={pieImg}
								alt="Pie de página del informe"
								className="w-full max-w-xs"
								style={{ maxHeight: '50px', objectFit: 'contain' }}
							/>
						</div>
					</div>
				</div>
				*/}

			</div>
		</div>
	);
};

export default PreviewPDF;